/**
 * @author      david.loehr@zumper.com (David Loehr)
 * @copyright   Copyright (c) 2020, Zumper
 * @description LinkToApp component
 */

import { rootRelative } from '@zcode/utils'
import React from 'react'
import type { App } from '../../App'

export type LinkOrButtonProps = {
  children: React.ReactNode
  className?: string
  onClick?: (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => void
  rel?: string
  target?: string
} & ({ href: string; to?: never } | { href?: never; to: string })

type Props = {
  children: React.ReactNode
  className?: string
  fromApp?: App
  LinkOrButton: React.FC<LinkOrButtonProps>
  onClick?: (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => void
  rel?: string
  to: string
  toApp: App
}

export const LinkToApp = ({ children, fromApp, LinkOrButton, to, toApp, ...props }: Props) => {
  if (fromApp !== toApp) {
    return (
      <LinkOrButton {...props} href={rootRelative(to)}>
        {children}
      </LinkOrButton>
    )
  }
  return (
    <LinkOrButton {...props} to={rootRelative(to)}>
      {children}
    </LinkOrButton>
  )
}
